var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('kst-input',{attrs:{"field":"Date","data":_vm.userData,"catalog":_vm.Catalog}}),_c('kst-input',{attrs:{"field":"PONumber","data":_vm.userData,"catalog":_vm.Catalog}}),_c('kst-input',{attrs:{"field":"ClientAddress","data":_vm.userData,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }